import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Avatar,
  Typography,
} from '@mui/material';
import { AddCard } from '@mui/icons-material';
import SubscribeButton from '../../SubscribeButton';

interface AddPaymentModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  planId: string;
  userData: any;
  paymentMethodLoading: boolean;
  setPaymentMethodLoading: (loading: boolean) => void;
  subscriptionId?: string;
}

export default function AddPaymentModal({
  open,
  onClose,
  onSuccess,
  planId,
  userData,
  paymentMethodLoading,
  setPaymentMethodLoading,
  subscriptionId
}: AddPaymentModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar sx={{ bgcolor: 'primary.main' }}>
            <AddCard />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={600}>
              Add a Card
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <SubscribeButton
          planId={planId}
          userData={userData}
          setShowAddPaymentDialog={onClose}
          paymentMethodLoading={paymentMethodLoading}
          setPaymentMethodLoading={setPaymentMethodLoading}
          canCancel={true}
          onSuccess={onSuccess}
          subscriptionId={subscriptionId}
          subscribe={false}
        />
      </DialogContent>
    </Dialog>
  );
}